import { useMemo } from "react";
import { ExtraStateContext } from "..";
import type { TableColumn } from "../../../../../../components/table";
import { GrantedArea, Photo } from "../../../../components/table-columns";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";

export const useShortTermTableColumns = () => {
  const { isRenew } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Tên phương tiện",
        renderCell: (row) => row.nameVehical,
      },
      {
        title: "Biển kiểm soát",
        renderCell: (row) => row.licensePlate,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantPeriod,
      },
      {
        title: "Số giấy đăng ký phương tiện / Số giấy phép khai thác thiết bị hàng không",
        renderCell: (row) => row.vehicleRegistrationCertificateId,
      },
      {
        title: "Giấy đăng ký phương tiện / Giấy phép khai thác thiết bị hàng không",
        renderCell: (row) => (
            <Photo src={row.vehicleRegistrationCertificate} />
        ),
      },
      {
        title:
          "Số chứng nhận kiểm định ATKT và BVMT giao thông / Số biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
        renderCell: (row) => row.certificateOfInspectionId,
      },
      {
        title:
          "Sổ chứng nhận kiểm định ATKT và BVMT giao thông / Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
        renderCell: (row) => (
          <Photo src={row.certificateOfInspection} />
        ),
      },
      {
        title: "Giấy phép lái xe",
        renderCell: (row) => <Photo src={row.driveLicense} />,
      },
      {
        title: "Khu vực đề nghị",
        renderCell: (row) => (
          <GrantedArea
            data={
              typeof row.grantedArea === "string"
                ? JSON.parse(row.grantedArea)
                : row.grantedArea ?? []
            }
          />
        ),
      },
      {
        title: "Cổng vào",
        renderCell: (row) => row.gateAway,
      },
      {
        title: "Cổng ra",
        renderCell: (row) => row.exit,
      },
      {
        title: "Đơn vị",
        renderCell: (row) => row.unit,
      },
      {
        hidden: !isRenew,
        title: "Bản photo giấy phép phương tiện đã cấp",
        renderCell: (row) => <Photo src={row.OldKSANCardPhoto} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => (
          <FileAttachmentCard listFile={row.ExcuseLose ? JSON.parse(row.ExcuseLose) : []} />
        ),
      },
    ];
  }, [isRenew]);
};

export const useLongTermTableColumns = () => {
  const { isRenew, isEvict } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Tên phương tiện",
        renderCell: (row) => row.nameVehical,
      },
      {
        title: "Biển kiểm soát",
        renderCell: (row) => row.licensePlate,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantPeriod,
      },
      {
        title: "Số giấy đăng ký phương tiện / Số giấy phép khai thác thiết bị hàng không",
        renderCell: (row) => row.vehicleRegistrationCertificateId,
      },
      {
        title: "Giấy đăng ký phương tiện / Giấy phép khai thác thiết bị hàng không",
        renderCell: (row) => (
          <FileAttachmentCard
            listFile={
              row.vehicleRegistrationCertificate
                ? JSON.parse(row.vehicleRegistrationCertificate)
                : []
            }
          />
        ),
      },
      {
        title:
          "Số chứng nhận kiểm định ATKT và BVMT giao thông / Số biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
        renderCell: (row) => row.certificateOfInspectionId,
      },
      {
        title:
          "Sổ chứng nhận kiểm định ATKT và BVMT giao thông / Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
        renderCell: (row) => (
          <FileAttachmentCard
            listFile={row.certificateOfInspection ? JSON.parse(row.certificateOfInspection) : []}
          />
        ),
      },
      {
        title: "Giấy phép lái xe",
        renderCell: (row) => <Photo src={row.driveLicense} />,
      },
      {
        title: "Khu vực đề nghị",
        renderCell: (row) => (
          <GrantedArea
            data={
              typeof row.grantedArea === "string"
                ? JSON.parse(row.grantedArea)
                : row.grantedArea ?? []
            }
          />
        ),
      },
      {
        title: "Cổng vào",
        renderCell: (row) => row.gateAway,
      },
      {
        title: "Cổng ra",
        renderCell: (row) => row.exit,
      },
      {
        title: "Đơn vị",
        renderCell: (row) => row.unit,
      },
      {
        title: "Số giấy phép phương tiện đã cấp",
        renderCell: (row) => row.NumberOfVehicleLicensesIssued,
      },
      {
        hidden: !isEvict,
        title: "Bản photo giấy phép phương tiện đã cấp",
        renderCell: (row) => <Photo src={row.OldKSANCardPhoto} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => (
          <FileAttachmentCard listFile={row.ExcuseLose ? JSON.parse(row.ExcuseLose) : []} />
        ),
      },
    ];
  }, [isEvict, isRenew]);
};
